<template>
    <div class="actuals">
        <form>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Webteksten">
                Webteksten
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Vooronderzoek">
                Vooronderzoek
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Wireframes">
                Wireframes
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Design">
                Design
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Frontend">
                Frontend
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Backend">
                Backend
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Staging">
                Staging
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="PM">
                PM
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Online Marketing">
                Online markerting
            </md-checkbox>
            <md-checkbox class="md-primary" v-model="filter.categories" value="Empty">
                Empty domain
            </md-checkbox>
            <md-field>
                <label>Name</label>
                <md-input v-model="filter.name"></md-input>
            </md-field>
        </form>
        <md-table table-header-color="primary">
            <tbody>
                <md-table-row>
                    <md-table-head>Category</md-table-head>
                    <md-table-head>Name</md-table-head>
                    <md-table-head>Author</md-table-head>
                    <md-table-head>Estimated</md-table-head>
                    <md-table-head>Logged</md-table-head>
                    <md-table-head>Percent</md-table-head>
                </md-table-row>
            </tbody>
            <tbody v-for="issue in filteredIssues" v-bind:key="issue.id">
                <md-table-row>
                    <md-table-cell>{{ issue.category }}</md-table-cell>
                    <md-table-cell>{{ issue.name }} [{{ issue.key }}]</md-table-cell>
                    <md-table-cell></md-table-cell>
                    <md-table-cell>{{ toHours(issue.time_estimated / 3600) }}</md-table-cell>
                    <md-table-cell>{{ toHours(loggedTime(issue.jira_issue_id) / 3600) }}</md-table-cell>
                    <md-table-cell :class="issue.time_estimated < loggedTime(issue.jira_issue_id) ? 'text-danger' : ''">{{ format((loggedTime(issue.jira_issue_id) / issue.time_estimated) * 100) }}%</md-table-cell>
                </md-table-row>
                <md-table-row v-for="(hours, user) in worklogs[issue.jira_issue_id]" v-bind:key="user" class="bg-grey-lighter">
                    <md-table-cell></md-table-cell>
                    <md-table-cell></md-table-cell>
                    <md-table-cell>{{ user }}</md-table-cell>
                    <md-table-cell></md-table-cell>
                    <md-table-cell>{{ toHours(hours / 3600) }}</md-table-cell>
                    <md-table-cell></md-table-cell>
                </md-table-row>
            </tbody>
            <tbody>
                <md-table-row class="table-total" v-if="!loading && filteredIssues.length">
                    <md-table-cell></md-table-cell>
                    <md-table-cell></md-table-cell>
                    <md-table-cell></md-table-cell>
                    <md-table-cell>{{ toHours(totalEstimated) }}</md-table-cell>
                    <md-table-cell>{{ toHours(totalLogged) }}</md-table-cell>
                    <md-table-cell :class="totalEstimated < totalLogged ? 'text-warning' : ''">{{ format((totalLogged / totalEstimated) * 100) }}%</md-table-cell>
                </md-table-row>
            </tbody>
        </md-table>
        <md-progress-spinner v-if="loading" md-mode="indeterminate"></md-progress-spinner>
    </div>
</template>

<script>
import axios from "@/axios";
import utils from "@/utils";

export default {
    name: "ProjectActuals",
    mixins: [utils],
    data() {
        return {
            loading: false,
            issues: [],
            worklogs: [],
            filter: {
                name: "",
                categories: []
            }
        };
    },
    methods: {
        fetch() {
            this.loading = true;
            axios.get("/projects/" + this.$route.params.id + "/issues")
                .then(e => {
                    this.issues = e.data.issues;
                    this.worklogs = e.data.worklogs;
                    this.loading = false;
                });
        },
        loggedTime(id) {
            let total = 0;
            Object.values(this.worklogs[id]).forEach(time => {
                total += time;
            });
            return total;
        }
    },
    mounted() {
        this.fetch();
    },
    computed: {
        filteredIssues() {
            return this.issues.filter(issue => {
                if (this.filter.categories.length == 0) {
                    if (!this.filter.name) {
                        return true;
                    }
                    return (issue.name.toLowerCase().includes(this.filter.name.toLowerCase()) ||issue.key.toLowerCase().includes(this.filter.name.toLowerCase()));
                } else {

                    if (!this.filter.categories.includes(issue.category)) return false;
                    return (issue.name.toLowerCase().includes(this.filter.name.toLowerCase()) || issue.key.toLowerCase().includes(this.filter.name.toLowerCase()));
                }
            });
        },
        totalEstimated() {
            let total = 0;
            this.filteredIssues.forEach(issue => {
                total += issue.time_estimated;
            });
            return total / 3600;
        },
        totalLogged() {
            let total = 0;
            this.filteredIssues.forEach(issue => {
                total += this.loggedTime(issue.jira_issue_id);
            });
            return total / 3600;
        }
    }
};
</script>

<style>
thead,
tbody {
    display: contents;
}
</style>
